import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Typography,
  Paper,
  Grid,
  FormControl,
  TextField,
} from "@material-ui/core";
import ApiService from "../../ApiService";
import MaterialTable from "../../components/MaterialTable";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import TableIcons from "../common/TableLogoComponent";
import { Alert, Autocomplete } from "@mui/material";
import Backdrop from "@material-ui/core/Backdrop";
import SearchIcon from "@material-ui/icons/Search";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "../../components/Custom/Button/Button";
import CustomTooltip from "../../components/Custom/Tooltip/Tooltip";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import {
  MuiPickersUtilsProvider,
  DatePicker,
  TimePicker,
} from "@material-ui/pickers";

const useStyles = (theme) => ({
  searchbar: {
    margin: theme.spacing(2),
  },
  formControl: {
    minWidth: 200,
    marginTop: 10,
  },
});

class RollingReserveComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      failed: false,
      success: false,
      responsemessage: null,
      fromDate: null,
      toDate: new Date(),
      fromTime: new Date().setHours(0, 0, 0),
      toTime: new Date().setHours(23, 59, 59),
      fromTimeStr: "00:00:00",
      toTimeStr: "23:59:59",
      entityIds: [],
      merchantTerminals: [],
      wires: [],
      label: [],
      merchants: [],
      selectedMerchant: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.search = this.search.bind(this);
    this.fetchMerchantTerminals = this.fetchMerchantTerminals.bind(this);
    this.terminalSelected = this.terminalSelected.bind(this);
  }

  componentDidMount() {
    this.fetchMerchantTerminals();
    this.fetchAllMerchants();
  }
  fetchAllMerchants = () => {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
    });
  };
  fetchMerchantTerminals() {
    ApiService.fetchMerchantTerminals().then((res) => {
      this.setState({ merchantTerminals: res.data });
    });
  }

  handleMerchantChange = (event, newValue) => {
    const selectedMer = newValue ? newValue.id : null;
    if (selectedMer) {
      this.setState({ selectedMerchant: selectedMer });
      this.showTerminalsById(selectedMer);
    } else {
      this.setState({
        selectedMerchant: null,
        label: [],
        entityIds: [],
      });
      this.fetchMerchantTerminals();
    }
  };

  showTerminalsById = (merchantId) => {
    if (merchantId || merchantId !== null) {
      ApiService.fetchMerchantTerminalsByMerId(merchantId)
        .then((res) => {
          this.setState({ merchantTerminals: res.data });
        })
        .catch((e) => {});
    }
  };
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      critChanged: true,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.success && prevState.success !== this.state.success) {
      this.clearMessage();
    }
    if (this.state.failed && prevState.failed !== this.state.failed) {
      this.clearMessage();
    }
  }
  clearMessage = () => {
    setTimeout(() => {
      this.setState({
        success: false,
        failed: false,
        responsemessage: null,
      });
    }, 3000);
  };

  terminalSelected = (event, value) => {
    const selectedTerminalIds = value.map((terminal) => terminal.terminalId);
    this.setState({ label: value, entityIds: selectedTerminalIds });
  };

  search() {
    if (
      this.state.entityIds.length === 0 ||
      this.state.fromDate === null ||
      this.state.toDate === null
    ) {
      this.setState({
        failed: true,
        success: false,
        responsemessage: "Please select all the fields",
      });
    } else {
      var reqForm = {
        fromDate: format(this.state.fromDate, "yyyyMMdd"),
        toDate: format(this.state.toDate, "yyyyMMdd"),
        entityIds: this.state.entityIds,
      };
      var request = Object.assign({}, reqForm);
      ApiService.fetchRRWireReport(request).then((res) => {
        this.setState({ wires: res.data.responseEntity });
      });
    }
  }

  showPdf(wireId) {
    ApiService.fetchWirePdf(
      wireId,
      format(this.state.fromDateObj, "yyyyMMdd") +
        "_" +
        format(this.state.toDateObj, "yyyyMMdd")
    );
  }

  showXLS(wireId) {
    ApiService.fetchWireXls(
      wireId,
      format(this.state.fromDateObj, "yyyyMMdd") +
        "_" +
        format(this.state.toDateObj, "yyyyMMdd")
    );
  }

  TerminalMenuProps = {
    PaperProps: {
      style: {
        maxHeight: this.ITEM_HEIGHT * 5.5 + this.ITEM_PADDING_TOP,
        width: 500,
      },
    },
  };
  render() {
    const { classes } = this.props;
    const { entityIds, merchantTerminals } = this.state;
    const dataWithSrNo =
      this.state.wires &&
      this.state.wires.map((item, index) => ({
        ...item,
        srNo: index + 1,
      }));

    return (
      <Paper style={{ margin: "1em", padding: "1em" }}>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          Rolling reserve Transactions
        </Typography>
        {this.state.failed && (
          <Alert severity="error" elevation={0}>
            {" "}
            {this.state.responsemessage}
          </Alert>
        )}
        {this.state.success && (
          <Alert severity="success" elevation={0}>
            {" "}
            {this.state.responsemessage}
          </Alert>
        )}
        <Grid container xs={12} spacing={1}>
          <Grid item xs={12}>
            <FormControl className={classes.formControl}>
              <Autocomplete
                options={this.state.merchants}
                getOptionLabel={(option) =>
                  option ? option.merchantName + "-" + option.code : ""
                }
                value={
                  this.state.merchants.find(
                    (merchant) => merchant.id === this.state.selectedMerchant
                  ) || null
                }
                style={{}}
                onChange={this.handleMerchantChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Merchants"
                    fullWidth
                    variant="standard"
                    size="small"
                  />
                )}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <Autocomplete
                multiple
                value={this.state.label}
                sx={{ width: 250, marginLeft: 3 }}
                onChange={this.terminalSelected}
                options={merchantTerminals}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.terminalId}>
                      {option.label + "-" + option.terminalCardType}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Terminal" />
                )}
              />
            </FormControl>
            &nbsp; &nbsp; &nbsp;
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                autoOk
                label="From"
                format="dd MMM yyyy"
                value={this.state.fromDate}
                onChange={(val) => this.setState({ fromDate: val })}
                style={{ marginTop: 10 }}
              />
              &nbsp; &nbsp; &nbsp;
              <TimePicker
                label="From Time"
                views={["hours", "minutes", "seconds"]}
                value={this.state.fromTime}
                format="HH:mm:ss"
                onChange={(val) =>
                  this.setState({
                    fromTime: val,
                    fromTimeStr: format(val, "HH:mm:ss"),
                  })
                }
                style={{ marginTop: 10 }}
              ></TimePicker>
              &nbsp; &nbsp; &nbsp;
              <DatePicker
                autoOk
                label="To"
                format="dd MMM yyyy"
                value={this.state.toDate}
                onChange={(val) => this.setState({ toDate: val })}
                style={{ marginTop: 10 }}
              />
              &nbsp; &nbsp; &nbsp;
              <TimePicker
                label="To Time"
                className="timePicker"
                views={["hours", "minutes", "seconds"]}
                value={this.state.toTime}
                format="HH:mm:ss"
                onChange={(val) =>
                  this.setState({
                    toTime: val,
                    toTimeStr: format(val, "HH:mm:ss"),
                  })
                }
                style={{ marginTop: 10 }}
              ></TimePicker>
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        <Grid
          justify="center"
          alignItems="center"
          style={{ marginTop: "2em" }}
          container
          xs={12}
        >
          <Grid item xs={2}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={classes.button}
              startIcon={<SearchIcon />}
              onClick={this.search}
            >
              Search
            </Button>
          </Grid>
          <Grid item xs={2}>
            <Backdrop
              open={this.state.loading}
              className={classes.backdrop}
              onClick={this.handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Grid>
        </Grid>

        <MaterialTable
          style={{ margin: "2em 0 0 0" }}
          title="Rolling Reserve Reports"
          icons={TableIcons.icons}
          columns={[
            {
              field: "srNo",
              title: "Sr. No.",
              hidden: true,
              export: true,
            },
            {
              field: "merchantName",
              title: "MERCHANT NAME",
            },
            {
              field: "merchantId",
              title: "MERCHANT ID",
              cellStyle: { minWidth: 30 },
              headerStyle: { minWidth: 30 },
              render: (rowData) => (
                <CustomTooltip title={rowData.merchantId} copy={true}>
                  <InfoOutlinedIcon />
                </CustomTooltip>
              ),
            },
            {
              field: "terminalId",
              title: "TERMINAL ID",
              cellStyle: { minWidth: 30 },
              headerStyle: { minWidth: 30 },
              render: (rowData) => (
                <CustomTooltip title={rowData.terminalId} copy={true}>
                  <InfoOutlinedIcon />
                </CustomTooltip>
              ),
            },
            { field: "currency", title: "CURRENCY" },
            { field: "cardScheme", title: "CARD SCHEME" },
            {
              field: "fromDate",
              title: "FROM DATE",
            },
            {
              field: "toDate",
              title: "To DATE",
            },
            {
              field: "totalProcessedAmount",
              title: "TOTAL PROCESSED AMOUNT",
            },
            {
              field: "rrcharge",
              title: "RR %",
            },
            {
              field: "rrfee",
              title: "RR FEE",
            },
          ]}
          data={dataWithSrNo}
          actions={[]}
          options={{
            search: false,
            exportButton: true,
            pageSize: 20,
            pageSizeOptions: [20, 50, 100],
            padding: "default",
            showEmptyDataSourceMessage: true,
            selection: false,
            actionsColumnIndex: -1,
            tableLayout: "auto",
            emptyRowsWhenPaging: false,
          }}
        />
      </Paper>
    );
  }
}

export default withStyles(useStyles)(RollingReserveComponent);
